import React, { useRef, useState } from "react";
import Body from "./Body";
import "../../../../../styles/Pages/Operational/Academic/Exams/Exams.style.css";
const ExamOverview = () => {
  const [examHistoryVal, setExamHistoryVal] = useState("all");
  const [addExamModal, setAddExamModal] = useState(false);
  const [historyViewerModal, setHistoryViewerModal] = useState(false);
  const [scrollHeaderOverviewContainer, setScrollHeaderOverviewContainer] =
    useState(0);
  const scrollHeaderOverviewContainerRef = useRef(null);

  const handelScroll = (direction) => {
    if (scrollHeaderOverviewContainerRef.current) {
      // convert rem → px
      const remInPx = parseFloat(
        getComputedStyle(document.documentElement).fontSize
      );

      const scrollBy = 20.5 * remInPx; // 18rem in px

      scrollHeaderOverviewContainerRef.current.scrollBy({
        left: direction === "right" ? scrollBy : -scrollBy,
        behavior: "smooth", // smooth scrolling
      });

      // keep track of total scrolled
      setScrollHeaderOverviewContainer((prev) =>
        direction === "right" ? prev + scrollBy : prev - scrollBy
      );
    }
  };
  const _this = {
    examHistoryVal,
    setExamHistoryVal,
    addExamModal,
    setAddExamModal,
    historyViewerModal,
    setHistoryViewerModal,
    scrollHeaderOverviewContainer,
    setScrollHeaderOverviewContainer,
    scrollHeaderOverviewContainerRef,
    handelScroll,
  };

  return <Body {..._this} />;
};

export default ExamOverview;
